<template>
    <img :src="src" />
</template>

<script>
export default {
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        src: R.compose(
            R.concat('/static/assets/img/'),
            R.ifElse(
                R.propEq('checked', true),
                R.always('checkbox_active.png'),
                R.always('checkbox_default.png')
            )
        ),
    },
};
</script>
